import * as C from './styles';

export const Header = () => {
    return (
        <C.Container>
            <C.TextArea>
                <h1>Cadastro no IMS Free Tier</h1>
                <p>Faça seu cadastro para receber alertas do seu ambiente em alguns minutos</p>
            </C.TextArea>
            <C.ImageArea>
                <img src="https://s3.amazonaws.com/logos-ims/dev/Free_Tier/IMS-Azul-fundo-Transparente-full-RGB.png" alt="IMS Network" />
            </C.ImageArea>
        </C.Container>
    )
}
